/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppTableExpandable.vue?vue&type=template&id=4acf2170&scoped=true"
import script from "./AppTableExpandable.ts?vue&type=script&lang=ts&external"
export * from "./AppTableExpandable.ts?vue&type=script&lang=ts&external"
import style0 from "./AppTableExpandable.vue?vue&type=style&index=0&id=4acf2170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf2170",
  null
  
)

export default component.exports